import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import CheckBoxField from "../../../../Form/CheckBoxField/CheckBoxField";
import { get, indexOf } from 'lodash';
import cn from "../../../../../utils/cn";
import highlightTerm from "./highlightTerm";
import FilterOptionChild from "./FilterOptionChild";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FilterOption = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    option,
    onChange,
    activeFilters = [],
    searchTerm = '',
    uniqIdPrefix = '',
    disableParentSelect = false,
    childRefs = []
  } = _ref;
  const label = searchTerm ? highlightTerm(option.label, searchTerm) : option.label;
  const id = `${uniqIdPrefix}${option.value}`;
  const filterOptionClass = cn({
    'h-full font-regular-font': true,
    'bg-dark-border-grey cursor-default': option.selectionDisabled
  });
  const parentOptionClass = cn({
    'px-3 py-2 min-h-10 place-content-center': true,
    'border-l-4 border-transparent': true,
    'hover:border-action-blue hover:bg-medium-fill-blue': !option.selectionDisabled && !disableParentSelect
  });
  const disabledParentClass = cn({
    'text-sm font-heavy-font': true,
    'opacity-50': option.selectionDisabled
  });
  const onMouseEnter = () => {
    if (!option.selectionDisabled && !disableParentSelect) {
      const children = Array.from(document.getElementsByClassName(`${id}__child`));
      children.forEach(child => {
        // does not add hover styles if it has selectionDisabled
        // eslint-disable-next-line no-param-reassign
        if (child.getAttribute('aria-disabled') === 'true') return;
        child.style.background = '#ECF5FD';
        child.style.borderLeft = '4px solid #4467AB';
      });
    }
  };
  const onMouseLeave = () => {
    if (!option.selectionDisabled && !disableParentSelect) {
      const children = Array.from(document.getElementsByClassName(`${id}__child`));
      children.forEach(child => {
        // eslint-disable-next-line no-param-reassign
        child.style.background = '';
        child.style.borderLeft = '';
      });
    }
  };
  if (get(option, 'hasChildren', false)) {
    return /*#__PURE__*/_jsxs("div", {
      className: filterOptionClass,
      children: [/*#__PURE__*/_jsx("div", {
        ref: ref,
        className: parentOptionClass,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: disableParentSelect ? /*#__PURE__*/_jsx("span", {
          className: disabledParentClass,
          children: label
        }) : /*#__PURE__*/_jsx(CheckBoxField, {
          "data-testid": disableParentSelect ? null : 'filter-option',
          id: id,
          label: label,
          value: indexOf(activeFilters, option.value) >= 0,
          onChange: e => onChange(option, e.target.checked),
          style: {
            label: 'uppercase font-heavy-font'
          },
          disabled: option.selectionDisabled
        })
      }), option.children.map((child, idx) => /*#__PURE__*/_jsx(FilterOptionChild, {
        ref: childRefs[idx],
        child: child,
        activeFilters: activeFilters,
        onChange: onChange,
        searchTerm: searchTerm,
        idPrefix: `${id}__`
      }, child.value))]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    "data-testid": "filter-option",
    className: filterOptionClass,
    children: /*#__PURE__*/_jsx("div", {
      className: parentOptionClass,
      children: /*#__PURE__*/_jsx(CheckBoxField, {
        id: id,
        label: label,
        value: indexOf(activeFilters, option.value) >= 0,
        onChange: e => onChange(option, e.target.checked),
        style: {
          label: 'capitalize'
        },
        disabled: option.selectionDisabled
      })
    })
  });
});
FilterOption.propTypes = {
  activeFilters: PropTypes.arrayOf(PropTypes.string),
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    initial: PropTypes.bool,
    selectionDisabled: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      initial: PropTypes.bool,
      selectionDisabled: PropTypes.bool
    }))
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  uniqIdPrefix: PropTypes.string,
  disableParentSelect: PropTypes.bool,
  childRefs: PropTypes.arrayOf(PropTypes.shape({
    current: PropTypes.element
  }))
};
export default FilterOption;
//# sourceMappingURL=FilterOption.js.map